import { render, staticRenderFns } from "./SmOwBtnToggle.vue?vue&type=template&id=304055fc&scoped=true&"
import script from "./SmOwBtnToggle.vue?vue&type=script&lang=ts&"
export * from "./SmOwBtnToggle.vue?vue&type=script&lang=ts&"
import style0 from "./SmOwBtnToggle.vue?vue&type=style&index=0&id=304055fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304055fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
